import { Center, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { OpenMinStdButton } from '@/module/MinimalStandard/components/OpenMinStdButton';

import { Content } from '@/core/components';

import { useCurrentUser } from '@/feature/security';

interface MinStdNotOpenedProps {
  userId: number;
}

export function MinStdNotOpened(props: MinStdNotOpenedProps) {
  const { userId } = props;
  const { id: currentUserId } = useCurrentUser();
  const { t } = useTranslation();

  return (
    <Content type="full">
      {currentUserId !== userId && (
        <Center>
          <Text
            fw="500"
            c="red"
          >
            {t('minStd.notOpenedOtherUsers')}
          </Text>
        </Center>
      )}
      {currentUserId === userId && (
        <Stack
          align="center"
          gap="md"
        >
          <Text fw="500">{t('minStd.noOpenedCurrentUser')}</Text>
          <OpenMinStdButton />
        </Stack>
      )}
    </Content>
  );
}
